import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles/other.css';
import { Link, Navigate } from "react-router-dom";
import Axios from 'axios';
import Moment from 'react-moment';

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';
import { getInitials, showSortIcon, numberWithSpaces } from '../utilities/OtherUtilities.js';

// import components
import ProfileImageSmall from '../components/ProfileImageSmall.js';

class SubmissionsTile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            redirectTo: null,
            selectedItems: [],
            showPopupTableActions: false,
        }

        this.refPopupTableActions = React.createRef();
    }

    componentDidMount(){
        this.setState({ redirectTo: null });
        window.addEventListener('click', this.onGlobalClick);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.onGlobalClick);
    }

    /* This method is triggered on every click on screen and is checking if some popup is opened nad user clicked out of this popup so it would close that popup in that situation */
    onGlobalClick = (e) => {
        if ( (!this.refPopupTableActions.current.contains(e.target)) && this.state.showPopupTableActions) {
            // user clicked out of the PopupTableActions and that popup is now opened
            this.setState({ showPopupTableActions: false })
        }
    }

    openSubmissionsProfilePage = (event, id, openTile) => {
        var openTileText = "";
        if(openTile != ""){
            openTileText = "?tile="+openTile;
        }
        if(event.ctrlKey || event.metaKey){ window.open("/Submission/"+id+""+openTileText, '_blank', 'noreferrer'); }
        else { this.setState({ redirectTo: "/Submission/"+id+""+openTileText }); }
    }

    render() {
        if (this.state.redirectTo) {
            return <Navigate to={this.state.redirectTo} />
        }

        return (
            <div style={{height: "calc(100% - 190px)", width: "100%"}}>
                <div className="universalTableTile">
                    <div style={{width: this.props.leftMenuOpened == "true" ? "calc(100% - 240px - 80px)" : "calc(100% - 90px - 80px)", height: "calc(100% - 80px - 120px - 145px)", position: "absolute", overflowX: "auto", overflowY: "auto"}}> {/* 240px including the padding */}
                        <table className="universalTable">
                            <tr>
                                <td className="universalTableHeader universalTableFirstFixedColumnHeader" onClick={() => this.props.changeSorting("nt_org")}>National Organization {showSortIcon("nt_org",this.props.sortBy,this.props.sortTp)}</td>
                                <td className="universalTableHeader universalTableSecondFixedColumnHeader" onClick={() => this.props.changeSorting("stmt_tp")}>Statement Type {showSortIcon("stmt_tp",this.props.sortBy,this.props.sortTp)}</td>
                                <td className="universalTableHeader universalTableThirdFixedColumnHeader" onClick={() => this.props.changeSorting("period")}>Period {showSortIcon("period",this.props.sortBy,this.props.sortTp)}</td>
                                <td className="universalTableHeader universalTableHeaderOther" onClick={() => this.props.changeSorting("stat")}>Status {showSortIcon("stat",this.props.sortBy,this.props.sortTp)}</td>
                                <td className="universalTableHeader universalTableHeaderOther" onClick={() => this.props.changeSorting("upd_by")}>Updated By {showSortIcon("upd_by",this.props.sortBy,this.props.sortTp)}</td>
                                <td className="universalTableHeader universalTableHeaderOther" onClick={() => this.props.changeSorting("ins_by")}>Created By {showSortIcon("ins_by",this.props.sortBy,this.props.sortTp)}</td>
                            </tr>

                            {this.props.submissionsData.map(function (item, index) {
                                return (
                                    <tr key={index}>

                                        <td className="universalTableFirstFixedColumn" onClick={(event) => this.openSubmissionsProfilePage(event, item.id, "")}>
                                            <div className="responsiveThreeDotsContainer flex">
                                                <span className="fontPoppinsRegular13 responsiveThreeDots">{item.nt_org}</span>
                                            </div>
                                        </td>

                                        <td className="universalTableNameDiv universalTableSecondFixedColumn" nowrap="nowrap" onClick={(event) => this.openSubmissionsProfilePage(event, item.id, "")}>
                                            <div className="responsiveThreeDotsContainer flex">
                                                <span className="fontPoppinsRegular13 responsiveThreeDots" style={{paddingRight: 20}}>{item.stmt_tp}</span>
                                            </div>
                                        </td>

                                        <td className="universalTableThirdFixedColumn" nowrap="nowrap" onClick={(event) => this.openSubmissionsProfilePage(event, item.id, "")}>
                                            <div className="responsiveThreeDotsContainer flex">
                                                <span className="fontPoppinsRegular13 responsiveThreeDots" style={{paddingRight: 20}}>{item.period}</span>
                                            </div>
                                        </td>
                                        <td className="universalTableGeneralDiv" nowrap="nowrap" onClick={(event) => this.openSubmissionsProfilePage(event, item.id, "")}>{item.stat}</td>
                                        <td className="universalTableGeneralDiv" nowrap="nowrap" onClick={(event) => this.openSubmissionsProfilePage(event, item.id, "")}>{item.upd_by}</td>
                                        <td className="universalTableGeneralDiv" nowrap="nowrap" onClick={(event) => this.openSubmissionsProfilePage(event, item.id, "")}>{item.ins_by}{/*numberWithSpaces(item.income)*/}</td>
                                    </tr>
                                )
                            }.bind(this))}

                            {/* if array empty then show row with text "Loading..." */}
                            {this.props.submissionsData.length == 0 && !this.props.noRecordsFound ? <tr> <td className="universalTableFirstFixedColumn" ></td> <td className="universalTableNameDiv universalTableSecondFixedColumn"></td> <td className="universalTableThirdFixedColumn"></td> <td className="universalTableGeneralDiv" nowrap="nowrap" colspan="3" style={{textAlign: "left"}}>{"Loading..."}</td> </tr> : null}

                            {/* if array empty then show row with text "No Records Found" */}
                            {this.props.submissionsData.length == 0 && this.props.noRecordsFound ? <tr> <td className="universalTableFirstFixedColumn" ></td> <td className="universalTableNameDiv universalTableSecondFixedColumn"></td> <td className="universalTableThirdFixedColumn"></td> <td className="universalTableGeneralDiv" nowrap="nowrap" colspan="3" style={{textAlign: "left"}}>{"No Records"}</td> </tr> : null}

                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default SubmissionsTile;
